import CloseImage from '@assets/svg/close.svg';

import {
  Close,
  Search,
  SearchContainer,
  StyledOption,
  Container,
  Div,
  ShowOptions,
} from './EditableSelect.styles';

export interface ContentAndIdAndManufacturer {
  content: string;
  id: string;
  manufacturerName?: string;
}
interface SearchBarProps {
  showOptions?: string[];
  searchText?: string;
  showErasedSearch?: boolean;
  closeIconOnClick?: () => void;
  handleClickSearch?: React.MouseEventHandler;
  onClickFilter?: (input: string) => void;
  active?: boolean;
  disabled?: boolean;
  'data-error': boolean;
  pinnedFields?: boolean;
}
const EditableSelect = ({
  searchText,
  showErasedSearch,
  closeIconOnClick,
  showOptions,
  onClickFilter,
  handleClickSearch,
  active,
  disabled,
  'data-error': error,
  pinnedFields,
  ...rest
}: SearchBarProps) => {
  return (
    <Div haveResults={showOptions ? showOptions.length > 0 : false}>
      <SearchContainer>
        {disabled ? (
          <Search
            onClick={handleClickSearch}
            active={active}
            disabled={disabled}
            empty={!searchText}
            {...rest}
          >
            {searchText || 'Empty'}
          </Search>
        ) : (
          <Search
            onClick={handleClickSearch}
            active={active}
            disabled={disabled}
            empty={!searchText}
            data-error={error}
            pinnedFields={pinnedFields}
          >
            {searchText || 'Empty'}
          </Search>
        )}

        {showErasedSearch && searchText && (
          <Close src={CloseImage} alt="close" onClick={closeIconOnClick} />
        )}
      </SearchContainer>
      {showOptions && showOptions.length > 0 && (
        <ShowOptions haveResults={showOptions.length > 0}>
          <Container haveResults={showOptions.length > 0}>
            {showOptions.map(item => (
              <StyledOption
                onClick={() => {
                  if (onClickFilter) {
                    onClickFilter(item);
                  }
                }}
                pinnedFields={pinnedFields}
              >
                {item}
              </StyledOption>
            ))}
          </Container>
        </ShowOptions>
      )}
    </Div>
  );
};

export { EditableSelect };
